import React from 'react';
import type { TFunction } from 'i18next';

import { fromDate } from '@/services/ws-invoice-sync/src/main/resources/rest-api';
import { TableCellContentType, Table, Icons } from '@/js/libs/ui/src/V2';

import Date from 'src/components/Date';
import type { Column } from './types';

export const useColumns = (t: TFunction) =>
  React.useMemo<Column[]>(
    () => [
      {
        name: 'month',
        title: t('common:MONTH'),
        component: ({ item }) => <Date value={fromDate(item.month)} />,
        dataTestId: 'month-column',
      },
      {
        name: 'deadline',
        title: t('common:DEADLINE'),
        component: ({ item }) => <Date value={fromDate(item.deadline)} />,
        dataTestId: 'deadline-column',
      },
      {
        name: 'actions',
        contentType: TableCellContentType.ACTION,
        component: ({ item, onEdit }) => (
          <Table.ActionButton onClick={() => onEdit(item)}>
            <Icons.Edit />
          </Table.ActionButton>
        ),
      },
    ],
    [t],
  );
